module.exports = __webpack_public_path__ + "img/widget_001.00f0b841.png";